import { render, staticRenderFns } from "./EventParticipant.vue?vue&type=template&id=efea8afa"
import script from "./EventParticipant.vue?vue&type=script&lang=js"
export * from "./EventParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports